import { API_ENDPOINTS } from "@/config/app";

import { apiClient } from "../client";
import type {
  AssignmentsOptionsResponse,
  RestaurantOptionsResponse,
  RestaurantOptionType,
  StatisticsRequest,
  StatisticsResponse,
} from "./types";

export const restaurantApi = {
  async getOptionsAssignments(): Promise<AssignmentsOptionsResponse> {
    const response = await apiClient.get<AssignmentsOptionsResponse>(
      `${API_ENDPOINTS.RESTAURANTS}/options/assignments`
    );
    return response;
  },

  async getOptions(
    types: RestaurantOptionType | RestaurantOptionType[]
  ): Promise<RestaurantOptionsResponse> {
    const typesArray = Array.isArray(types) ? types : [types];
    const query = typesArray.map(t => `types=${t}`).join("&");

    const response = await apiClient.get<RestaurantOptionsResponse>(
      `${API_ENDPOINTS.RESTAURANTS}/options?${query}`
    );
    return response;
  },

  async postStatistics(body: StatisticsRequest): Promise<StatisticsResponse> {
    let url = `${API_ENDPOINTS.RESTAURANTS}/statistics`;
    if ("allBrands" in body && body.allBrands) {
      url = `${API_ENDPOINTS.RESTAURANTS}/statistics/brands`;
    } else if ("allBranches" in body && body.allBranches) {
      url = `${API_ENDPOINTS.RESTAURANTS}/statistics/branches`;
    }

    const timezoneOffsetMinutes = -new Date().getTimezoneOffset();

    const requestBody = {
      ...body,
      timezoneOffsetMinutes,
    };

    return apiClient.post<StatisticsResponse>(url, requestBody);
  },
};
